module.exports = __webpack_public_path__ + "img/nextLevel.d8325162.png";